import React, { useState, useEffect } from "react";

function WHTd({
  dataHeader,
  onClick,
  activeTime,
  dentistactiveTime,
  deactiveTime,
  dentistdeactiveTime,
  edit,
}: any) {
  const [dentistactive, setdentistactive] = useState(false);
  const [disable, setdisable] = useState(false);
  const [dentistdisable, setdentistdisable] = useState(false);
  const [active, setactive] = useState(false);

  useEffect(() => {
    setactive(activeTime);
    setdisable(deactiveTime);
    setdentistactive(dentistactiveTime);
    setdentistdisable(dentistdeactiveTime);
  }, [activeTime, deactiveTime, dentistactiveTime, dentistdeactiveTime]);

  const handleClick = () => {

    setdentistdisable(!dentistdisable);
    onClick({
      ...dataHeader,
      active: !dentistdisable,
    });
  };

  return (

    <td className="px-2 py-2 text-center">
      <button
        onClick={() =>
          edit && active && !disable && dentistactive && handleClick()
        }
        // disabled={!edit || !clinicOpen}
        className={`w-8 h-8 rounded-lg transition-all ${
          active
            ? disable
              ? "bg-slate-100 cursor-not-allowed" //dental closed by date wise
              : dentistactive //dentist closed by week days
                ? dentistdisable
                  ? "bg-purple-500 shadow-md shadow-purple-200"
                  : "bg-amber-500 shadow-md shadow-amber-200"
                : "bg-slate-100 cursor-not-allowed"
            : "bg-slate-100 cursor-not-allowed"
        } `}
      />
    </td>
  );
}

export default WHTd;
